import { render, staticRenderFns } from "./CreateTickerSettings.vue?vue&type=template&id=a11df144&scoped=true"
import script from "./CreateTickerSettings.vue?vue&type=script&lang=js"
export * from "./CreateTickerSettings.vue?vue&type=script&lang=js"
import style0 from "./CreateTickerSettings.vue?vue&type=style&index=0&id=a11df144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11df144",
  null
  
)

export default component.exports